module.exports = __webpack_public_path__ + "img/earth.81355622.svg";